export default {
  translation: {
    processState: {
      loading: 'Идёт загрузка',
      loaded: 'RSS успешно загружен',
    },
    errors: {
      url: {
        noRss: 'Ресурс не содержит валидный RSS',
        invalid: 'Ссылка должна быть валидным URL',
        notUnique: 'RSS уже существует',
      },
      network: 'Ошибка сети',
    },
    postPreviewButton: 'Просмотр',
    feedsHeader: 'Фиды',
    postsHeader: 'Посты',
  },
};
